import React from "react";
import styled from "styled-components";
import Info from "../comps/ContactInfo";
import LText from "../comps/LogoText";
import TopNav from "../comps/Top";
import logo from "../images/logo.png";

const Contact = () => {
  return (
    <Container>
      <TopNav />
      <LText
        text={"Contate-me"}
        subtext={
          "Entre em contato ainda hoje e nos deixe te ajudar a conquistar uma vida melhor!"
        }
      />
      <Info />
    </Container>
  );
};

export default Contact;

const Container = styled.div`
  width: 100%;
  min-height: calc(100vh - 150px);
  height: 100%;
  padding-bottom: 40px;
  background-color: #537bae;
`;
